import React from 'react';
import { observer } from "mobx-react";
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { priceFormatter } from "../../Services/Formatters/PriceFormatter";
import {ShowableProductCardHtmlIdentifierEnum} from "../../Types/enum";

type AdditionalProductsV1Props = {
    productCard: ShowableProductCard
}

const AdditionalProductsV1 = observer((props: AdditionalProductsV1Props) => {

    let {currentProductConfig} = props.productCard;

    if (props.productCard.isLoadingAdditionalProducts || !currentProductConfig) {
        return <div>Загрузка...</div>;
    }

    const additionalProductsContainer =
            document.getElementById(ShowableProductCardHtmlIdentifierEnum.additionalProductsContainerId)
    ;
    if (additionalProductsContainer) {
        additionalProductsContainer.style.display = 'block';
    }
    if (!props.productCard.additionalProducts || props.productCard.additionalProducts.length === 0) {

        if (additionalProductsContainer) {
            additionalProductsContainer.style.display = 'none';
        }
        return null;
    }


    const uniqueKey = currentProductConfig.getUniqueId();

    const collection = props.productCard.additionalProducts.map((product, index) => {
        return (
            <div className="input-checkbox-v1" key={`ap-${index}`}>
                <div className="form-group field-dummymodel-additionalproducts">
                    <input type="hidden" name="DummyModel[additionalProducts]" value="0" />
                        <label>
                            <input type="checkbox"
                                   data-product-id={product.id}
                                   data-product-type-id={product.productTypeId}
                                   className="input-checkbox-v1__input"
                                   name="DummyModel[additionalProducts]"
                                   value="1"
                            />
                            <div className="input-checkbox-v1__label-block">
                                <span className="input-checkbox-v1__checkbox-label">{product.title}</span>
                                <span className="input-checkbox-v1__checkbox-mark">{priceFormatter.format(product.salePrice)}</span>
                            </div>
                        </label>
                        <div className="help-block"></div>
                </div>
            </div>
        );
    })

    return (
        <div className="input-radio-list-v1" key={uniqueKey}>
            {collection}
        </div>
    );

})

export { AdditionalProductsV1 };